import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {
  Label,
  InputGroup,
  Input
} from 'reactstrap'
import moment from 'moment'
import 'moment/locale/de';
import Calendar from 'rc-calendar'
import DatePicker from 'rc-calendar/lib/Picker'
import 'rc-calendar/assets/index.css'
import deDE from 'rc-calendar/lib/locale/de_DE'
import 'rc-time-picker/assets/index.css'
import TimePickerPanel from 'rc-time-picker/lib/Panel'

class FieldDatetime extends Component {
  constructor(props) {
    super(props)

    moment.locale('de')

    this.state = {
      date: this.props.cardField.fieldValue === null ?
            moment() : moment(this.props.cardField.fieldValue)
    }

    this.returnValue = this.returnValue.bind(this)
  }

  handleTimeChange(momentObj) {
    this.setState({
      date: momentObj ? momentObj : null
    })
  }

  returnValue() {
    return this.state.date.format() || moment().format()
  }

  render() {
    const timePickerElement = <TimePickerPanel showSecond={false}
                                defaultValue={this.state.date}
                                defaultOpenValue={this.state.date} />

    function disabledDate(current) {
      if (!current) {
        return false
      }
      const date = moment()
      date.hour(0)
      date.minute(0)
      date.second(0)
      return current.valueOf() < date.valueOf()  // can not select days before today
    }

    const fieldClassName = `card-field field-datetime ${this.props.cardField.fieldClassName ? this.props.cardField.fieldClassName : ''}`

    return this.props.isEditing || this.props.cardType === 'always-on' ? <div className={fieldClassName}>
      <Label for={this.props.cardField.id}>{this.props.cardField.fieldLabel}</Label>
      <Calendar
        locale={deDE}
        className="mb-3"
        timePicker={timePickerElement}
        showDateInput={false}
        showOk={false}
        disabledDate={disabledDate}
        onChange={momentObj => { this.handleTimeChange(momentObj) }}
        onPanelChange={(date, mode) => { date.locale('de') }}
        defaultValue={this.state.date}
      />
    </div> : <div className={fieldClassName}>
      <Label className="mb-0" for={this.props.cardField.id}>{this.props.cardField.fieldLabel}</Label>
      <div className="mb-3">{moment(this.props.cardField.fieldValue).format('LLL')}</div>
    </div>
  }
}

FieldDatetime.propTypes = {
  cardField: PropTypes.object,
  isEditing: PropTypes.bool,
  cardType: PropTypes.string
}

FieldDatetime.defaultProps = {
  cardField: {
    cardSublabel: ''
  }
}

export default FieldDatetime


// WEBPACK FOOTER //
// ./src/components/EditableCard/FieldDatetime.js